import { useContext, useMemo } from 'react'
import translationGroups from 'client/constants/translationGroups'
import TranslationContext from 'client/contexts/TranslationContext'
import countryCodes from 'assets/countries/codes.json'

const useCountryOptions = () => {
  const { getRawTranslation } = useContext(TranslationContext)

  return useMemo(() => {
    // Create a map with a translation for each country
    const translationMap = countryCodes.reduce((acc, value) => {
      acc.set(value, getRawTranslation(translationGroups.form, `country-option-${value}`))
      return acc
    }, new Map<string, string>())

    // Sort the options based on their translation
    const optionsSorted = Array.from(translationMap.keys())
    optionsSorted.sort((keyA, keyB) => {
      if (translationMap.get(keyA) < translationMap.get(keyB)) {
        return -1
      }
      if (translationMap.get(keyA) > translationMap.get(keyB)) {
        return 1
      }
      return 0
    })

    return {
      translationMap,
      optionsSorted,
    }
  }, [getRawTranslation])
}

export default useCountryOptions
